// extracted by mini-css-extract-plugin
export default {"image":"ImageAndTitle_image__mTFoG","title":"ImageAndTitle_title__spCqm"};